module.exports = __webpack_public_path__ + "img/Front-Contour-Reference5@2x.76be867e.jpg";